module.exports = __webpack_public_path__ + "static/media/about.5e67ae41.svg";